import { render } from "./MdNavigationItem.vue?vue&type=template&id=a54ca10c&scoped=true&ts=true"
import script from "./MdNavigationItem.vue?vue&type=script&lang=ts"
export * from "./MdNavigationItem.vue?vue&type=script&lang=ts"

import "./MdNavigationItem.vue?vue&type=style&index=0&id=a54ca10c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54ca10c"]])

export default __exports__